<template>
  <div class="settlement-subcomponent">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#c44f0b"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#c44f0b" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: white">
            {{ msg }}
          </span>
        </v-flex>

        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div v-if="check1 == true && savedList">
      <div v-if="savedList.length > 0">
        <!-- Settlement Items Table -->
        <div class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th class="text-center" style="width: 44px;">Select</th>
                <th class="text-center" style="width: 44px;">#</th>
                <th class="text-center" style="width: 120px;">Touch Rate (%)</th>
                <th class="text-left">Design</th>
                <th class="text-center">Count</th>
                <th class="text-right">Net Wt (gm)</th>
                <th class="text-right" style="width: 140px;">Thankam Rate (₹)</th>
                <th class="text-right">Thankam (gm)</th>
                <th class="text-right">Pending Thankam</th>
                <th class="text-center">Status</th>
                <th class="text-center" style="width: 80px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, i) in savedList"
                :key="i"
                class="table-row"
              >
                <!-- Select Checkbox -->
                <td class="text-center">
                  <v-checkbox
                    color="#c44f0b"
                    :disabled="
                      value.touchRate == '0' || value.touchRate == '' || value.touchRate > 100 || value.settleStatus == 'Settled' ? true : false
                    "
                    @click="selectThis(value.checkbox, value._id)"
                    v-model="value.checkbox"
                    hide-details
                    dense
                    class="ma-0 pa-0 inline-checkbox"
                  ></v-checkbox>
                </td>

                <!-- S.No -->
                <td class="text-center cell-muted">{{ i + 1 }}</td>

                <!-- Touch Rate Input -->
                <td class="text-center">
                  <v-form v-model="addcat" ref="addcat" @submit.prevent>
                    <v-text-field
                      :disabled="
                        value.checkbox == true || value.settleStatus == 'Settled' ? true : false
                      "
                      placeholder="0"
                      color="#c44f0b"
                      type="number"
                      outlined
                      dense
                      flat
                      :rules="[maxValueRule, minValueRule]"
                      @input="cal7(i)"
                      v-model="value.touchRate"
                      hide-details="auto"
                      class="compact-cell-input text-center-input"
                    ></v-text-field>
                  </v-form>
                </td>

                <!-- Design -->
                <td class="text-left">
                  <span v-if="value.designId && value.designId.code" class="code-pill">
                    {{ value.designId.code }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>

                <!-- Count -->
                <td class="text-center font-weight-medium">
                  {{ value.initialCount || '-' }}
                </td>

                <!-- Net Wt -->
                <td class="text-right font-weight-bold text-dark">
                  {{ value.initialnetWeight ? (value.initialnetWeight).toFixed(2) : '-' }}
                </td>

                <!-- Thankam Rate Input -->
                <td class="text-right">
                  <v-text-field
                    :disabled="
                      value.checkbox == true || value.settleStatus == 'Settled' ? true : false
                    "
                    v-model="value.thankamRate"
                    placeholder="Rate"
                    outlined
                    dense
                    flat
                    color="#c44f0b"
                    hide-details
                    class="compact-cell-input text-right-input"
                  ></v-text-field>
                </td>

                <!-- Thankam (gm) -->
                <td class="text-right font-weight-bold text-dark">
                  {{ value.thankam ? (value.thankam).toFixed(2) : '0' }}
                </td>

                <!-- Pending Thankam -->
                <td class="text-right font-weight-bold" :class="value.tobePaidThankam > 0 ? 'text-amber-dark' : 'text-muted'">
                  {{ value.tobePaidThankam ? (value.tobePaidThankam).toFixed(2) : '0.00' }}
                </td>

                <!-- Status -->
                <td class="text-center">
                  <span
                    v-if="value.settleStatus === 'Settled'"
                    class="status-pill status-settled"
                  >
                    <span class="status-dot dot-settled"></span>
                    Settled
                  </span>
                  <span
                    v-else-if="value.settleStatus === 'notSettled'"
                    class="status-pill status-not-settled"
                  >
                    <span class="status-dot dot-not-settled"></span>
                    Not Settled
                  </span>
                  <span
                    v-else-if="value.settleStatus === 'partiallySettled'"
                    class="status-pill status-partially-settled"
                  >
                    <span class="status-dot dot-partially-settled"></span>
                    Partially Settled
                  </span>
                  <span v-else class="text-muted">-</span>
                </td>

                <!-- Action (Edit / Reset) -->
                <td class="text-center">
                  <v-btn
                    v-if="value.settleStatus !== 'notSettled'"
                    class="btn-compact reset-btn"
                    outlined
                    small
                    depressed
                    @click="resetsettlement(value)"
                  >
                    <v-icon left x-small>mdi-pencil-outline</v-icon>
                    Edit
                  </v-btn>
                  <span v-else class="text-muted">-</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Settlement Action Panel (Shown when selected.length > 0) -->
        <div v-if="flag1 == true && selected.length > 0" class="settlement-bottom-bar">
          <!-- Thankam Metric Badges -->
          <div class="d-flex flex-wrap align-center justify-space-between settlement-summary-header pa-3 px-4">
            <div class="d-flex align-center flex-wrap gap-3">
              <div class="metric-pill">
                <span class="metric-label">Balance Thankam:</span>
                <span class="metric-val text-amber-dark">{{ (prevThankam) ? Number(prevThankam).toFixed(2) : '0.00' }} gm</span>
              </div>
              <div class="metric-pill">
                <span class="metric-label">Total Thankam:</span>
                <span class="metric-val text-dark">{{ totalThankam ? totalThankam.toFixed(2) : '0.00' }} gm</span>
              </div>
            </div>
            <div class="selected-count-tag">
              {{ selected.length }} item{{ selected.length > 1 ? 's' : '' }} selected
            </div>
          </div>

          <!-- Payment Form Row -->
          <div class="payment-form-row pa-4 d-flex flex-wrap align-center justify-space-between">
            <div class="d-flex flex-wrap align-center gap-3">
              <!-- Payment Type -->
              <div class="form-group-compact">
                <label class="form-label-compact">Payment Type</label>
                <v-select
                  v-model="paymentTypes"
                  :items="type"
                  placeholder="Select Type"
                  outlined
                  dense
                  hide-details
                  color="#c44f0b"
                  class="compact-select"
                ></v-select>
              </div>

              <!-- Cash Amount -->
              <div class="form-group-compact" v-if="paymentTypes == 'Cash' && check == false">
                <div class="d-flex align-center justify-space-between">
                  <label class="form-label-compact">Cash Amount (₹)</label>
                  <span v-if="thankamRate && totalThankam" class="required-hint">
                    Req: ₹ {{ (parseFloat(totalThankam) * parseFloat(thankamRate)).toFixed(2) }}
                  </span>
                </div>
                <v-text-field
                  autofocus
                  v-model="cash"
                  outlined
                  dense
                  hide-details
                  color="#c44f0b"
                  placeholder="0.00"
                  @input="cal3()"
                  class="compact-input"
                ></v-text-field>
              </div>

              <!-- Eq. Thankam -->
              <div class="form-group-compact" v-if="paymentTypes == 'Cash'">
                <label class="form-label-compact">Eq. Thankam (gm)</label>
                <v-text-field
                  disabled
                  v-model="eqthankam"
                  outlined
                  dense
                  hide-details
                  class="compact-input disabled-input"
                ></v-text-field>
              </div>

              <!-- Balance Amount to fully settle -->
              <div class="form-group-compact" v-if="paymentTypes == 'Cash' && thankamRate && totalThankam">
                <label class="form-label-compact">Balance Amt (₹)</label>
                <v-text-field
                  disabled
                  :value="balanceAmount.toFixed(2)"
                  outlined
                  dense
                  hide-details
                  class="compact-input disabled-input"
                ></v-text-field>
              </div>

              <!-- Own Jewellery Thankam Balance -->
              <div class="form-group-compact" v-if="paymentTypes == 'Thankam'">
                <label class="form-label-compact">Available Balance (gm)</label>
                <v-text-field
                  disabled
                  :value="Number(jewelleryThankamBalance).toFixed(2)"
                  outlined
                  dense
                  hide-details
                  class="compact-input disabled-input"
                ></v-text-field>
              </div>

              <!-- Amount of own Thankam to apply -->
              <div class="form-group-compact" v-if="paymentTypes == 'Thankam'">
                <div class="d-flex align-center justify-space-between">
                  <label class="form-label-compact">Apply Thankam (gm)</label>
                  <span v-if="totalThankam" class="required-hint">
                    Req: {{ totalThankam.toFixed(2) }} gm
                  </span>
                </div>
                <v-text-field
                  autofocus
                  v-model="ownThankamAmount"
                  outlined
                  dense
                  hide-details="auto"
                  color="#c44f0b"
                  placeholder="0.00"
                  type="number"
                  :error-messages="ownThankamAmount > jewelleryThankamBalance ? ['Exceeds available balance'] : []"
                  class="compact-input"
                ></v-text-field>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="mt-3 mt-md-0">
              <v-btn
                class="btn-compact primary-action-btn generate-btn"
                depressed
                :disabled="paymentTypes == 'Thankam' && (!ownThankamAmount || parseFloat(ownThankamAmount) <= 0 || parseFloat(ownThankamAmount) > jewelleryThankamBalance)"
                @click="AddItem()"
              >
                <v-icon left x-small>mdi-check-circle-outline</v-icon>
                Generate Bill
              </v-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center py-6 text-muted">
        <v-icon medium color="#9ca3af" class="mb-1">mdi-alert-circle-outline</v-icon>
        <div style="font-size: 13px;">No settlement record found</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      snackbar: false,
      timeout: 2000,
      msg: null,
      billDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      type: ["Cash", "Thankam"],
      isSelectAll: false,
      savedList: [],
      selected: [],
      thankam3: null,
      gold3: null,
      prevThankam:"0",
      CalculatedBalanceThankam:0,
      // prevThankam:0,
      check2:false,
      sflag: true,
      paymentTypes: [],
      paytype: null,
      type1: [],
      cash: 0,
      isLock: false,
      thankam1: 0,
      Weight: 0,
      Price1: 0,
      touchrate: 0,
      pay: false,
      proceed: false,
      balanceThankam: 0,
      totalThankam: 0,
      eqthankam: 0,
      check3: false,
      gold: 0,
      gold1: 0,
      purchasedata: {},
      invoiceDate: null,
      invoiceDate1: null,
      newbilldate1: null,
      newbilldate: null,
      // thankamRate: localStorage.getItem("thankamRate"),
      thankamRate: null,
      checkvalue: false,
      check8:false,
      purchaseId: null,
      totalmakingcharge: 0,
      totalnetweight: 0,
      initialnetWeight:0,
      totalAmount: 0,
      check1:false,
      purchaseId2: null,
      calresponse: {},
      payment: [
        {
          paymentType: null,
          payAmount: null,
        },
      ],
      thankamDetails: [
        {
          thankamId: "63d3a2d42d13b00bbea3a98f",
          boardingRate: null,
          thankamWeight: null,
          batchCode: null,
        },
      ],
      flag1: false,
      GstStat: "GST",
      paymentDetails: [],
      check: false,
      // deletedialog:false,
      deleteItem:[],
      addcat:false,
      jewelleryThankamBalance: 0,
      ownThankamAmount: 0,
    };
  },

  computed: {
    balanceAmount() {
      var required = (parseFloat(this.totalThankam) || 0) * (parseFloat(this.thankamRate) || 0);
      var paid = parseFloat(this.cash) || 0;
      var balance = required - paid;
      return balance > 0 ? balance : 0;
    },
  },

  mounted() {
    this.getData();
    this.getJewelleryThankamBalance();
    // this.savedListCopy = this.savedList;

  },
  watch: {
    selected() {
      // this.calctotal();
      this.calthankamTotal();
      console.log("1")
    },
    // paymentTypes() {
    //   this.checkpaymenttype();
    // },
  },
  methods: {
    maxValueRule(value) {
      if (value > 100) {
        return "Max.value is 100";
      }
      return true;
    },
    minValueRule: (value) => {
      if (value < 1) {
        return 'Min.value is 1'
      } else {
        return true
      }
    },
    cal3() {
      console.log("thankamRate", this.thankamRate);
      var eqthankam1 = this.cash / this.thankamRate;
      this.eqthankam = eqthankam1.toFixed(2);
      console.log("eqthankam", this.eqthankam);

    },
    cal7(i) {
      this.check1=false;
      this.newtouchrate = parseFloat(this.savedList[i].touchRate);
      console.log("initialnetWeight==", this.savedList[i].initialnetWeight);
      console.log("newtouchrate==", this.newtouchrate);

      this.savedList[i].thankam =
        this.savedList[i].initialnetWeight * (this.newtouchrate / 100);
      console.log("value==", this.savedList[i].thankam);

      this.savedListCopy = this.savedList;
      console.log("newarray=", this.savedListCopy);
      this.savedList = this.savedListCopy
      this.check1=true;
    },
    markAll() {
      if (this.isSelectAll) {
        this.selected = [];
        this.sflag = false;
        for (let i = 0; i < this.savedList.length; i++) {
          this.savedList[i].checkbox = true;
          this.selected.push(this.savedList[i]._id);
        }
        console.log("markeD", this.selected);
        // console.log("Ddata=", this.isSelectAll);
        this.sflag = true;
      } else {
        this.sflag = false;
        for (let i = 0; i < this.savedList.length; i++) {
          this.savedList[i].checkbox = false;
          this.selected = [];
        }
        console.log("Rem", this.selected);
        // console.log("Ddata=", this.isSelectAll);
        this.sflag = true;
      }
    },
    selectThis(val, id) {
      this.isSelectAll = false;
      console.log("id=", id);
      if (val == true) {
        if (this.selected.length > 0) {
          if (!id.includes(this.selected)) {
            this.selected.push(id);
            console.log("ll=");
          }
        } else {
          this.selected.push(id);
        }
      } else {
        var ar = this.selected;
        this.selected = ar.filter((x) => x != id);
      }

      console.log("selected id==", this.selected);
      console.log("savedListCopy==", this.savedListCopy);

    },
    calthankamTotal(){
      var finalArray = this.savedListCopy.filter(x=>this.selected.includes(x._id.toString()))
      console.log("array=",finalArray)
      console.log("len=",finalArray.length)

      var thankamTotal1=0;
      var thankamTotal=0;

      for(var i=0;i<finalArray.length;i++){
      thankamTotal1 = Math.abs(finalArray[i].thankam)
        thankamTotal+= thankamTotal1;
        
      }
   

      this.totalThankam=thankamTotal;
      console.log("totalThankam=",this.totalThankam)
      console.log("2")
      this.calctotal();
    },
    calctotal() {
      if(this.selected.length>0){
      axios({
        method: "Post",
        url: "/multiple/purchase/itemcalculation",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          items: this.savedListCopy,
          currentpurchaseItemId: this.selected,
          supplierId: this.supplierId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.calresponse = response.data.finalcalculation;
            this.thankamRate = response.data.finalcalculation.thankamRate;
            this.totalThankam=response.data.finalcalculation.totalThankam;
            console.log("tt==",response.data.finalcalculation.totalThankam)
            this.prevThankam = response.data.finalcalculation.balanceThankam;
            if (this.prevThankam) {
              this.pay = true;
            }
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
      }
    },
    getData() {
      // this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/item/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          billNo: this.$route.query.billno,
          purchaseId: this.$route.query.id,
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.savedList = response.data.data;
      this.savedListCopy = this.savedList;
console.log("savedListCopy",this.savedListCopy)
      this.check1=true;
            if (this.savedList.length > 0) {
              this.flag1 = true;
            } else {
              this.flag1 = false;
            }
            this.paymentDetails = response.data.payment;
            console.log("pay=", response.data.payment);
            this.purchasedata = response.data.purchasedata;
            this.supplierId = this.purchasedata.supplierId._id;
            this.isLock = response.data.purchasedata.isLock;
            this.newbilldate = response.data.purchasedata.create_date;
            this.newbilldate1 = this.formatDate(this.newbilldate);
            this.invoiceDate = response.data.purchasedata.invoiceDate;
            this.invoiceDate1 = response.data.purchasedata.invoiceDate;
            this.invoiceDate1 = this.formatDate(this.invoiceDate1);
            console.log("invoiceDate1=", this.invoiceDate1);
            this.thankamRate = response.data.purchasedata.thankamRate;
            this.thankam1 = this.thankamRate;
            this.invoiceDate = this.invoiceDate1;
            this.purchaseno = response.data.purchasedata._id;
            this.totalMakingCharge = response.data.totalMakingCharge;
            this.totalnetweight = response.data.totalnetweight;
            this.finalTotal = response.data.finalTotal;
            // this.Pagelength = Math.ceil(response.data.count / 20);
          } else {
            this.showsnackbar = true;
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getJewelleryThankamBalance() {
      axios({
        method: "GET",
        url: "/oldgold/acidifiedthankam/balance",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.jewelleryThankamBalance = response.data.acidifiedThankam || 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    AddItem() {
      var isOwnThankam = this.paymentTypes == "Thankam";
      axios({
        url: "/purchase/payment",
        method: "POST",
        data: {
          balanceThankam: this.balanceThankam,
          currentpurchaseItems: this.selected,
          paymentType: this.paymentTypes,
          payAmount: isOwnThankam ? 0 : this.cash,
          totalThankamWeight: this.totalThankam,
          touchRate: this.touchrate,
          gold: this.gold,
          thankamRate: this.thankamRate,
          purchaseId: this.purchaseno,
          // paidThankam: this.CalculatedBalanceThankam,
          paidThankam: isOwnThankam ? 0 : parseFloat(this.eqthankam),
          useOwnThankam: isOwnThankam,
          ownThankamAmount: isOwnThankam ? parseFloat(this.ownThankamAmount) : 0,

        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.selected = [];
            this.paymentTypes = [];
            this.cash = 0;
            this.totalThankam = 0;
            this.thankamRate = 0;
            this.eqthankam = 0;
            this.ownThankamAmount = 0;
            this.getData();
            // this.$router.push('/PurchaseList');
            // this.check = true;
            // console.log("check=", this.check);
            // this.returndata = response.data;
            location.reload();
          } else {
            this.check = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    thankamCal() {
      axios({
        url: "/purchaseitem/calculation",
        method: "POST",
        data: {
          items: this.savedListCopy,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // this.appLoading = false;
          if (response.data.status == true) {
            this.savedListCopy = [];
            // this.msg = response.data.msg;
            // this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    setLockoff() {
      this.isLock = false;
      localStorage.setItem("isLock", this.isLock);
      console.log("lock", this.isLock);
      this.LockItem();
    },
    LockItem() {
      axios({
        url: "/purchase/lock",
        method: "POST",
        data: {
          thankamRate: this.thankamRate,
          purchaseId: this.purchaseno,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;
      //  +
      // " , " +
      // hours +
      // ":" +
      // minutes +
      // " " +
      // ampm;

      return strTime;
    },
    deletesettlement(){
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/settlement/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          thankam: this.deleteItem.thankam,
          id: this.deleteItem._id,
          tobePaidThankam: this.deleteItem.tobePaidThankam,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // this.paymentDetails = response.data.payment;
            this.snackbar = true;
            this.msg = response.data.msg;
            this.selected = [];
            this.paymentTypes = [];
            this.cash = 0;
            this.totalThankam = 0;
            this.thankamRate = 0;
            this.getData();
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    resetsettlement(item){
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/purchase/settlement/reset",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          thankam: item.thankam,
          id: item._id,
          tobePaidThankam: item.tobePaidThankam,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            // this.paymentDetails = response.data.payment;
            this.showsnackbar = true;
            this.snackbar = true;
            this.msg = response.data.msg;
            this.selected = [];
            this.paymentTypes = [];
            this.cash = 0;
            this.totalThankam = 0;
            this.thankamRate = 0;
            this.getData();
            this.$refs.addcat.resetValidation();

          } else {
            this.showsnackbar = true;
            this.snackbar = true;
            this.msg = response.data.msg;
          }

          // this.msg = response.data.msg;

          // this.snackbar = true;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@400;500;600;700&display=swap");

.settlement-subcomponent {
  font-family: "Plus Jakarta Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #1e293b;
}

/* Custom Table */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
}

/* Sleek subtle scrollbar */
.table-responsive::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #cbd5e1 !important;
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #94a3b8 !important;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.custom-table thead {
  background-color: #f8fafc;
}

.custom-table th {
  padding: 12px 14px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  white-space: nowrap;
  border-bottom: 1px solid #e2e8f0;
}

.custom-table td {
  padding: 12px 14px;
  font-size: 13px;
  color: #1e293b;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
  vertical-align: middle;
}

.table-row {
  transition: background-color 0.12s ease;
}

.table-row:hover {
  background-color: #fafaf9;
}

.cell-muted {
  color: #94a3b8;
  font-size: 12px;
}

.code-pill {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12.5px;
  font-weight: 600;
  color: #0f172a;
  background-color: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  display: inline-block;
}

/* Status Badges */
.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 9999px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.4;
  gap: 5px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-settled {
  background-color: #ecfdf5;
  color: #065f46;
  border: 1px solid #a7f3d0;
}

.dot-settled {
  background-color: #10b981;
}

.status-not-settled {
  background-color: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.dot-not-settled {
  background-color: #ef4444;
}

.status-partially-settled {
  background-color: #fffbeb;
  color: #92400e;
  border: 1px solid #fde68a;
}

.dot-partially-settled {
  background-color: #f59e0b;
}

.text-amber-dark {
  color: #b45309 !important;
}

.text-dark {
  color: #0f172a !important;
}

.text-muted {
  color: #9ca3af;
}

/* Inputs in table cells */
.compact-cell-input >>> .v-input__control {
  min-height: 32px !important;
}

.compact-cell-input >>> .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  padding: 0 10px !important;
  font-size: 12.5px !important;
  border-color: #e2e8f0 !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
}

.compact-cell-input >>> input {
  font-size: 12.5px !important;
  color: #0f172a !important;
  font-weight: 600 !important;
}

.text-center-input >>> input {
  text-align: center !important;
}

.text-right-input >>> input {
  text-align: right !important;
}

.inline-checkbox >>> .v-input__slot {
  justify-content: center;
}

/* Buttons */
.btn-compact {
  height: 32px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px !important;
  padding: 0 12px !important;
  border-radius: 7px !important;
  text-transform: none !important;
}

.reset-btn {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
  color: #475569 !important;
  transition: all 0.2s ease !important;
}

.reset-btn:hover {
  border-color: #9a6b27 !important;
  color: #9a6b27 !important;
  background-color: #fffaf5 !important;
}

.primary-action-btn {
  background: linear-gradient(135deg, #b9893f 0%, #875c24 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 14px rgba(154, 106, 44, 0.28) !important;
  transition: all 0.2s ease !important;
  border-radius: 10px !important;
}

.primary-action-btn:hover {
  background: linear-gradient(135deg, #c59449 0%, #956627 100%) !important;
  box-shadow: 0 6px 18px rgba(154, 106, 44, 0.38) !important;
  transform: translateY(-1px);
}

.generate-btn {
  height: 36px !important;
  padding: 0 18px !important;
  font-size: 12.5px !important;
}

/* Settlement Bottom Bar */
.settlement-bottom-bar {
  background-color: #ffffff;
  border-top: 1px solid #ede8e0;
}

.settlement-summary-header {
  background-color: #faf8f5;
  border-bottom: 1px solid #f1ece5;
}

.metric-pill {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 4px 12px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.metric-label {
  font-size: 11.5px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.metric-val {
  font-size: 13px;
  font-weight: 700;
}

.selected-count-tag {
  font-size: 11.5px;
  font-weight: 600;
  color: #9a6b27;
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
  padding: 3px 12px;
  border-radius: 9999px;
}

.payment-form-row {
  background-color: #ffffff;
  padding: 16px 20px;
}

.form-group-compact {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.form-label-compact {
  font-size: 11px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}

.required-hint {
  font-size: 11px;
  font-weight: 700;
  color: #9a6b27;
}

.compact-select {
  width: 140px;
}

.compact-select >>> .v-input__control,
.compact-select >>> .v-input__slot {
  min-height: 34px !important;
  height: 34px !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}

.compact-input {
  width: 150px;
}

.compact-input >>> .v-input__control,
.compact-input >>> .v-input__slot {
  min-height: 34px !important;
  height: 34px !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}

.disabled-input >>> .v-input__slot {
  background-color: #f8fafc !important;
}

.gap-3 {
  gap: 12px;
}
</style>
